import { typography, colors } from 'settings';
import { Color } from 'settings/colors';
import { FontFamily, FontFamilyLinksSize } from 'settings/typography';

export function getLinkColor(color: Color) {
    return color === 'chameleon' ? 'currentColor' : colors[color];
}

export function getLinkSize(size: FontFamilyLinksSize) {
    return `${typography.fontSizes.links[size]}px`;
}

export function getLinkFontFamily(fontFamily: FontFamily) {
    return typography.fontFamilies[fontFamily];
}
